import { useStore } from "@nanostores/solid";
import { Link } from "@tanstack/solid-router";
import { Show, createSignal } from "solid-js";
import { IconLogo, IconMenu } from "~/components/icons";
import { Sheet, SheetContent, SheetTrigger } from "~/components/ui/sheet";
import { authClient } from "~/lib/auth-client";

export function MobileNav(props: { tone?: "light" | "dark" }) {
  const [open, setOpen] = createSignal(false);
  const session = useStore(authClient.useSession);

  return (
    <Sheet open={open()} onOpenChange={setOpen}>
      <SheetTrigger
        class={`
          ${props.tone === "dark" ? "text-foreground" : "text-white"}
          flex size-8 items-center justify-center md:hidden
        `}
      >
        <IconMenu class="size-5" />
        <span class="sr-only">Toggle Menu</span>
      </SheetTrigger>
      <SheetContent position="left" class="pr-0">
        <Link
          to="/"
          class="flex items-center space-x-3 mb-6"
          onClick={() => setOpen(false)}
        >
          <IconLogo class="size-8" fill="currentColor" />
          <div class="flex flex-col justify-center">
            <span class="text-lg font-bold leading-none tracking-tight">
              ActShark
            </span>
            <span class="text-[10px] font-medium uppercase leading-none tracking-[0.2em] text-muted-foreground">
              accounting
            </span>
          </div>
        </Link>

        <div class="h-[calc(100vh-8rem)] overflow-y-auto pb-10 pr-4">
          <div class="border-t pt-4">
            <Show
              when={session().data}
              fallback={
                <div class="grid gap-2">
                  <Link
                    to="/login"
                    search={{ mode: "login" }}
                    class="inline-flex h-9 items-center justify-center rounded-md border border-input px-3 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground"
                    onClick={() => setOpen(false)}
                  >
                    Sign In
                  </Link>
                  <Link
                    to="/login"
                    search={{ mode: "register" }}
                    class="inline-flex h-9 items-center justify-center rounded-md bg-primary px-3 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
                    onClick={() => setOpen(false)}
                  >
                    Get Started
                  </Link>
                </div>
              }
            >
              <div class="grid gap-2">
                <Link
                  to="/dashboard"
                  class="inline-flex h-9 items-center justify-center rounded-md bg-primary px-3 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
                  onClick={() => setOpen(false)}
                >
                  Dashboard
                </Link>
                <button
                  type="button"
                  class="inline-flex h-9 items-center justify-center rounded-md border border-input px-3 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground"
                  onClick={() => {
                    setOpen(false);
                    void authClient.signOut();
                  }}
                >
                  Sign Out
                </button>
              </div>
            </Show>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
